import React from 'react'
import clsx from 'clsx'
import { DynamicHeading } from '@/components/molecules/DynamicHeading/DynamicHeading'
import { Image } from '@/components/atoms/Image/Image'
import { EventAnnouncerProps } from './types'

export function EventAnnouncer({
  sub_heading,
  heading,
  event_date,
  date_icon,
  event_time,
  time_icon,
  left
}: EventAnnouncerProps) {
  return (
    <section
      className={clsx(
        'text-center px-24 pb-32 netbook:max-w-44 netbook:mx-auto netbook:pb-64',
        left && 'laptop:text-left laptop:px-0'
      )}
    >
      <p className="text-bodyL text-primary-600 uppercase tracking-wide font-bold">{sub_heading}</p>
      {!!heading.length && (
        <DynamicHeading
          {...heading[0]}
          className="text-headingL-mobile font-bold text-text-dark-900 mx-auto w-full mb-24 my-8 netbook:text-headingL netbook:mt-16 netbook:mb-32"
        />
      )}
      {event_date && event_time && (
        <div
          className={clsx(
            'flex flex-col justify-center items-center netbook:flex-row',
            left ? 'laptop:justify-start' : 'netbook:justify-around'
          )}
        >
          <div
            className={clsx('flex flex-row justify-center items-center mb-24 netbook:mb-0', left && 'netbook:mr-40')}
          >
            <Image fixed data={date_icon} className="mr-20" options={{ width: 25, height: 25 }} />
            <p className="text-text-dark-900">{event_date}</p>
          </div>
          <div className="flex flex-row justify-center items-center mb-24 netbook:mb-0">
            <Image fixed data={time_icon} className="mr-20" options={{ width: 25, height: 25 }} />
            <p className="text-text-dark-900">{event_time}</p>
          </div>
        </div>
      )}
    </section>
  )
}
